import Index from "./Index.vue";
import Show from "./Show.vue";
import Edit from "./Edit.vue";

export default [
  {
    path: "",
    name: "UsersOrganizationsIndex",
    component: Index,
    meta: {
      title: "組織管理",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: ":id",
    name: "UsersOrganizationsShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          title: "組織管理",
          name: "UsersOrganizationsIndex",
        },
      ],
    },
  },
  {
    path: ":id/edit",
    name: "UsersOrganizationsEdit",
    component: Edit,
    meta: {
      title: "編集",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          title: "組織管理",
          name: "UsersOrganizationsIndex",
        },
        {
          title: "詳細",
          name: "UsersOrganizationsShow",
        },
      ],
    },
  },
];
